import { render, staticRenderFns } from "./clientContentBoard.vue?vue&type=template&id=2bbee0c0&scoped=true&"
import script from "./clientContentBoard.vue?vue&type=script&lang=js&"
export * from "./clientContentBoard.vue?vue&type=script&lang=js&"
import style0 from "./clientContentBoard.vue?vue&type=style&index=0&id=2bbee0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbee0c0",
  null
  
)

export default component.exports